<template>
  <div class="login  animated fadeIn">
    <div class="container">
      <el-form
        :model="loginForm"
        :rules="rules"
        class="login-container  animated bounceInDown"
        label-position="left"
        label-width="0px"
        v-loading="loading"
      >
        <h5 class="text-center text-white">系统登录</h5>
        <el-form-item prop="username">
          <el-input
            type="text"
            v-model="loginForm.username"
            class="mt-3"
            prefix-icon="el-icon-user"
            auto-complete="off"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            prefix-icon="el-icon-lock"
            @keyup.enter.native="login"
            auto-complete="off"
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <button
            class="btn btn-block btn-info mt-2"
            type="button"
            v-on:click="login"
          >
            登录
          </button>
        </el-form-item>
      </el-form>
      <div class="text-center animated bounceInUp">
        <a
          href="http://www.soft178.com/"
          class="text-white text-decoration-none"
          >© 2020 杭州多一步科技有限公司</a
        >
      </div>
    </div>
  </div>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
export default {
  name: "Login",
  data() {
    return {
      rules: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      },
      checked: false,
      loginForm: {
        username: "",
        password: ""
      },
      loading: false,
      responseResult: []
    };
  },
  methods: {
    login() {
      this.axios
        .post("/login/login", {
          username: this.loginForm.username,
          password: this.loginForm.password
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$store.commit("login", resp.data.data);
            let path = this.$route.query.redirect;
            this.$router
              .replace({
                path:
                  path === "/" || path === undefined ? "/admin/dashboard" : path
              })
              .catch();
          } else {
            this.$alert(resp.data.message, "提示", {
              confirmButtonText: "确定"
            });
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.login {
  background: url("../assets/img/bg/bg.jpg");
  width: 100%;
  height: 100%;
  position: fixed;

  .login-container {
    /*width: 400px;*/
    background-color: rgba(248, 248, 255, 0.2);
    max-width: 400px;
    border-radius: 5px;
    padding: 30px;
    margin: 150px auto;
    /*box-shadow: 0 0 25px #cac6c6;*/
  }
}
</style>
